<template>
  <div class="text-center searchBox flex flex-jc-c text-center">
    <div class="searchBox__Inputs">
      <input
        class="form-control searchBox__Inputs-input"
        :placeholder="placeholder"
        v-model="wordEntered"
        @input="handleFilterData"
      />
      <div class="searchBox__Icon">
        <i v-if="filteredData.length === 0" class="fas fa-search"></i>
        <i
          v-else
          class="fas fa-times searchbox__clearBtn"
          @click="clearInput"
        ></i>
      </div>
    </div>

    <div v-if="filteredData.length > 0" class="searchBox__dataResult">
      <router-link
        v-for="(item, index) in filteredData.slice(0, 15)"
        :key="index"
        :to="`/coverage/${formatName(item.name)}`"
        class="searchBox__dataResult-item"
      >
        {{ item.name }} - {{ item.code }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'SearchBox',
  props: {
    placeholder: {
      type: String,
      default: 'Search...'
    },
    data: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const wordEntered = ref('')
    const filteredData = ref([])

    const handleFilterData = () => {
      const searchWord = wordEntered.value.toLowerCase()
      if (searchWord === '') {
        filteredData.value = []
      } else {
        filteredData.value = props.data.filter(item =>
          item.name.toLowerCase().includes(searchWord)
        )
      }
    }

    const clearInput = () => {
      wordEntered.value = ''
      filteredData.value = []
    }

    const formatName = (name) => {
      return name
        .toLowerCase()
        .replace(/[^a-zA-Z ]/g, '')
        .replace(/\s/g, '')
    }

    return {
      wordEntered,
      filteredData,
      handleFilterData,
      clearInput,
      formatName
    }
  }
}
</script>

<style scoped>
.searchBox {
  position: absolute;
  z-index: 1;
  text-align: center;
}

.searchBox__Inputs {
  position: relative;
  display: flex;
  margin: 5rem 0 2rem 0;
  left: 28vw;
}

@media (max-width: 1200px) {
  .searchBox__Inputs {
    left: 20vw;
  }
}

@media (max-width: 992px) {
  .searchBox__Inputs {
    left: 13.5vw;
  }
}

.searchBox__Inputs-input {
  background-color: white;
  border-radius: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  font-size: 18px;
  padding: 15px;
  width: 60vw;
}

.searchBox__Inputs-input:focus {
  outline: none;
}

@media (min-width: 1200px) {
  .searchBox__Inputs-input {
    width: 800px;
  }
}

.searchBox__Icon {
  width: 50px;
  background-color: white;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: black;
  display: grid;
  place-items: center;
  border: 1px solid lightgrey;
}

.searchBox__dataResult {
  position: absolute;
  margin-top: 5px;
  top: 20vh;
  left: 30vw;
  height: 200px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  overflow: hidden;
  overflow-y: auto;
  width: 40vw;
}

.searchBox__dataResult::-webkit-scrollbar {
  display: none;
}

.searchBox__dataResult-item {
  display: flex;
  align-items: center;
  color: black;
  padding: 1rem;
  height: 30px;
  width: 100%;
}

.searchBox__dataResult-item:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 3px 5px;
  color: blue;
  border-radius: 10px;
  cursor: pointer;
}

.searchBox__clearBtn {
  cursor: pointer;
}
</style>
